import React, { useEffect, useRef, useState } from 'react';
import { Check, ChevronDown, Search } from 'lucide-react';

// Searchable, scrollable sector picker. Selection only — no free-text sector creation.
export const SectorSelect = ({ sectors = [], value, onChange, disabled, required, testId = 'lead-form-sector' }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  const selected = sectors.find((s) => s.sector_id === value);
  const filtered = sectors.filter((s) => s.name.toLowerCase().includes(q.trim().toLowerCase()));

  return (
    <div className="relative" ref={ref}>
      <button type="button" disabled={disabled} data-testid={testId} onClick={() => setOpen((o) => !o)}
        className={`flex w-full items-center justify-between rounded-lg border border-slate-200 bg-white px-3 py-2 text-left text-sm
          disabled:opacity-60 dark:border-slate-700 dark:bg-slate-900 ${!selected ? 'text-slate-400' : ''}`}>
        <span className="truncate">{selected ? selected.name : `Select sector${required ? '' : ' (optional)'}`}</span>
        <ChevronDown className="h-4 w-4 shrink-0 text-slate-400" />
      </button>
      {open && !disabled && (
        <div data-testid={`${testId}-menu`}
          className="absolute z-30 mt-1 w-full rounded-lg border border-slate-200 bg-white shadow-lg dark:border-slate-700 dark:bg-slate-900">
          <div className="flex items-center gap-2 border-b border-slate-100 px-2 py-1.5 dark:border-slate-800">
            <Search className="h-3.5 w-3.5 text-slate-400" />
            <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search sector…"
              data-testid={`${testId}-search`} className="w-full bg-transparent text-sm outline-none" />
          </div>
          <div className="max-h-56 overflow-y-auto py-1" data-testid={`${testId}-list`}>
            {!required && (
              <button type="button" data-testid={`${testId}-option-none`}
                onClick={() => { onChange(''); setOpen(false); setQ(''); }}
                className="block w-full px-3 py-1.5 text-left text-sm text-slate-500 hover:bg-slate-50 dark:hover:bg-slate-800">
                Not specified
              </button>
            )}
            {filtered.map((s) => (
              <button key={s.sector_id} type="button" data-testid={`${testId}-option-${s.sector_id}`}
                onClick={() => { onChange(s.sector_id); setOpen(false); setQ(''); }}
                className="flex w-full items-center justify-between px-3 py-1.5 text-left text-sm hover:bg-slate-50 dark:hover:bg-slate-800">
                <span>{s.name}</span>
                {s.sector_id === value && <Check className="h-3.5 w-3.5 text-primary" />}
              </button>
            ))}
            {filtered.length === 0 && <p className="px-3 py-2 text-xs text-slate-400">No sector matches</p>}
          </div>
        </div>
      )}
    </div>
  );
};

export default SectorSelect;
